import { Heading, VStack } from '@chakra-ui/react';

import { ArticlePreview } from 'components/ArticlePreview';
import { getLayout } from 'layouts/AritclesIndexLayout';
import { parseAllArticles } from 'lib/server/articles';

import { Meta } from 'components/HeadContent';

export type ArticlesIndexPageProps = {
  articlesMetaData: Record<string, any>;
  ogImageUrl: string;
  url: string;
};

export async function getStaticProps() {
  const articlesMetaData = await parseAllArticles();
  const url = `${process.env.SITE_URL}/articles`;
  const ogImageUrl = `${process.env.SITE_URL}/articles/jamstack-logo-og.png`;

  articlesMetaData.sort(
    (a, b) => new Date(b.data.date).getTime() - new Date(a.data.date).getTime()
  );

  return {
    props: {
      articlesMetaData,
      ogImageUrl,
      url,
    },
  };
}

export default function ArticlesIndexPage({
  articlesMetaData,
  ogImageUrl,
  url,
}: ArticlesIndexPageProps) {
  return (
    <>
      <Meta
        titlePrefix="Full-Stack Jamstack Articles"
        description="Articles about building full-stack web applications with next-generation JavaScript libraries, including React, Next.js, Chakra-UI, Prisma ORM and more."
        seo={{
          openGraph: {
            url,
            images: [
              {
                url: ogImageUrl,
                width: 1200,
                height: 628,
                alt: 'Jamstack Logo',
              },
            ],
          },
        }}
      />

      <article>
        <Heading textAlign="center" size="xl" as="h1" fontWeight={600} mb={12}>
          Recent Articles
        </Heading>

        <VStack w={{ base: '100%', md: '60%' }} m="0 auto" spacing="15px">
          {articlesMetaData.map(({ data: { title, excerpt }, slug }) => {
            return (
              <ArticlePreview
                key={slug}
                slug={slug}
                title={title}
                excerpt={excerpt}
              />
            );
          })}
        </VStack>
      </article>
    </>
  );
}

ArticlesIndexPage.getLayout = getLayout;
